/**
 * Page visibility, once (work holds the box, spec §5).
 *
 * Fourteen files in this app read `document.visibilityState` their own way. The panes that
 * hold a box open (the browser stream, a live app frame) need one answer to "is anyone
 * looking", so this is it. `focus` is paired in as a second wake signal: webviews skip
 * `visibilitychange` on restore (useConvergingRead.ts:28-30). A visible tab on a second
 * monitor is visible; nothing here needs `blur`.
 *
 * The flag is read at CALL time so tests can stub it and the off path is byte-identical.
 */
export const PANE_HIDDEN_GRACE_MS = 10_000;

export function isPaneVisibilityEnabled(): boolean {
  return process.env.NEXT_PUBLIC_PANE_VISIBILITY_V1 === "true";
}

export function isPageVisible(): boolean {
  if (typeof document === "undefined") return true;
  return document.visibilityState === "visible";
}

export function subscribePageVisibility(fn: (visible: boolean) => void): () => void {
  if (typeof document === "undefined") return () => {};
  const onChange = () => fn(isPageVisible());
  const onFocus = () => fn(true);
  document.addEventListener("visibilitychange", onChange);
  window.addEventListener("focus", onFocus);
  return () => {
    document.removeEventListener("visibilitychange", onChange);
    window.removeEventListener("focus", onFocus);
  };
}
